import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { Button, Checkbox } from '@material-ui/core';
import Allocation from './allocation';
import Definition from './definition';
import cssClasses from './rules.css';




const RuleItem = (props) => {
    const { rule, chart, expanded, onExpand, updateRule, deleteRule, selected, removeCheckboxClicked } = props;
    const chartItem = chart.find(transaction => transaction.value === rule.Allocation[0].AccountCode);
    const accountCode = (rule.Allocation[0].AccountCode.length !== 20) ? rule.Allocation[0].AccountCode : '';
    const accountName = (chartItem) ? `${accountCode ? ' / ' : ''}${chartItem.label}` : '';

    return (
        <div className={(expanded === rule.RuleGuid) ? cssClasses.newExpansionPanel : cssClasses.newRuleDevider}>
        <div className={cssClasses.newRuleDevider} />
        <ExpansionPanel expanded={expanded === rule.RuleGuid} onChange={() => onExpand(rule.RuleGuid)}>
            <ExpansionPanelSummary expandIcon={<i className="fas fa-angle-down"></i>}>
                <div className={cssClasses.newRuleRow}>
                    <div style={{width:"80px"}}><Checkbox onChange={() => removeCheckboxClicked(rule.RuleGuid)} checked={selected && selected.includes(rule.RuleGuid)} /></div>
                    <div>{rule.Description}</div>
                    <div>{(rule.Allocation.length === 1) ? `${accountCode}${accountName}` : 'Split'}</div>
                    <div>{(rule.MoneyInOut === '1') ? 'Money In' : 'Money Out'}</div>
                </div>

            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <div className={cssClasses.newRuleDetails}>
                    <div>
                        <div className={cssClasses.newRuleSubHeading}>Match transactions where:</div>
                        <div>{rule.Definition.map((item, index) => <Definition key={index} item={item} />)}</div>
                    </div>
                    <div>
                        <div className={cssClasses.newRuleSubHeading}>Allocate transaction:</div>
                        <div>{rule.Allocation.map((item, index) => <Allocation key={index} item={item} chart={chart} />)}</div>
                    </div>
                    <div>
                        <div className={cssClasses.newRuleButtonContainer}><Button size="small" variant="outlined" color="primary" className={cssClasses.newRuleButton} onClick={() => updateRule(rule)}>Edit Rule</Button></div>
                        <div><Button size="small" variant="outlined" color="secondary" className={cssClasses.newRuleButton} onClick={() => deleteRule(rule.RuleGuid)}>Delete Rule</Button></div>
                    </div>
                </div>
            </ExpansionPanelDetails>
        </ExpansionPanel>
        </div>
    );
}

export default RuleItem;


// WEBPACK FOOTER //
// ./src/components/Rules/ruleItem.js